import utils from "../../../utils/utils.js";

export default {
  async fetchEngagementQueues(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetEngagementQueues?pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}`,
      "GET",
      null,
      null
    );
    context.commit("setEngagementQueues", responseData.data);
  },
  async fetchEngagementQueueSourceFeeders(context) {
    const response = await utils.utility.fetch(
      `api/Setting/GetEngagementQueueSourceFeeders`,
      "GET",
      null,
      null
    );

    context.commit("setEngagementQueueSourceFeeders", response.data);
  },
  async fetchEngagementQueueDetail(context, payload) {
    const response = await utils.utility.fetch(
      `api/Setting/GetEngagementQueueDetail?id=${payload.id}`,
      "GET",
      null,
      null
    );

    context.commit("setEngagementQueueDetail", response.data);
  },

  async postEngagementQueue(context, payload) {
    await utils.utility.fetch(
      `api/Setting/CreateEngagementQueue`,
      "POST",
      null,
      payload
    );
  },
  async putEngagementQueue(context, payload) {
    await utils.utility.fetch(
      `api/Setting/UpdateEngagementQueue`,
      "PUT",
      null,
      payload
    );
  },

  async deleteEngagementQueue(context, payload) {
    let postData = { id: payload.id };
    await utils.utility.fetch(
      `api/Setting/DeleteEngagementQueue`,
      "POST",
      null,
      postData
    );
  },
  async emptyEngagementQueue(context, payload) {
    let postData = { id: payload.id };
    await utils.utility.fetch(
      `api/Setting/EmptyEngagementQueue`,
      "POST",
      null,
      postData
    );
  },
};
